import { Link } from 'react-router-dom';
import { getCategorySeoContent } from './categorySeoContent';
import { HOME_PATH, MENU_CATEGORIES } from '../../utils/constant';
import './categorySeo.css';

interface CategoryDescriptionProps {
  categoryName: string;
}

export default function CategoryDescription({ categoryName }: CategoryDescriptionProps) {
  const content = getCategorySeoContent(categoryName);
  if (!content) return null;

  return (
    <section
      className="category-seo"
      aria-label={`${content.label} live streams information`}
    >
      <h2 className="category-seo-h2">{content.headline}</h2>
      <p className="category-seo-text">{content.intro}</p>

      <h3 className="category-seo-h3">{content.liveEventsHeading}</h3>
      <p className="category-seo-text">{content.liveEvents}</p>

      <h3 className="category-seo-h3">{content.howToWatchHeading}</h3>
      <ol className="category-seo-steps">
        {content.howToWatch.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>

      <h3 className="category-seo-h3">{content.coverageHeading}</h3>
      <p className="category-seo-text">{content.coverage}</p>

      <h3 className="category-seo-h3">{content.whyHeading}</h3>
      <ul className="category-seo-list">
        {content.whyPoints.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>

      <p className="category-seo-text">{content.closing}</p>

      <nav className="category-seo-nav" aria-label="More sports categories">
        <h4 className="category-seo-h4">More Free Live Streams</h4>
        <ul className="category-seo-links">
          <li>
            <Link to={HOME_PATH}>All fixtures today</Link>
          </li>
          {MENU_CATEGORIES.filter(
            (cat) => cat.value.toLowerCase() !== categoryName.toLowerCase(),
          ).map((cat) => (
            <li key={cat.value}>
              <Link to={`/streams/${cat.value}`}>{cat.label} streams</Link>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  );
}
